import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../CustomPDFViewer/styled";
import {
  ButtonContainer,
  ButtonMobile,
  ContentWrapper,
  HeaderWrapper,
  StepContainer,
  StepNumber,
  Wrapper,
} from "./styled";

interface HeaderProps {
  showButton?: boolean;
  currentStep: number;
  visible?: boolean;
  isHome?: boolean;
  position?: "relative" | "";
}

const Header: React.FC<HeaderProps> = ({
  showButton,
  currentStep,
  visible,
  isHome,
  position = "",
}) => {
  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const id = urlParams.get("id");
  const pathname = process.env.REACT_APP_PATHNAME;
  const urlSettings = `${pathname}settings?id=${id}`;

  return (
    <HeaderWrapper isHome={isHome} position={position}>
      <ContentWrapper>
        <Wrapper>
          <img
            src={`${pathname}logo_preta.png`}
            alt="Assinando"
            style={{
              margin: "5px 10px",
              height: "auto",
              width: "160px",
            }}
          />
          <ButtonMobile
            backgroundColor="#355B94"
            hoverBackgroundColor="#32568C"
            isFilled={true}
            showButton={showButton}
          >
            {urlSettings && <Link to={urlSettings}>Editar perfil</Link>}
          </ButtonMobile>
        </Wrapper>

        <StepContainer visible={visible}>
          <StepNumber
            status={
              currentStep > 1
                ? "passed"
                : currentStep === 1
                ? "current"
                : "pending"
            }
          >
            1
          </StepNumber>
          <p>Identificar</p>
          <hr />
          <StepNumber
            status={
              currentStep > 2
                ? "passed"
                : currentStep === 2
                ? "current"
                : "pending"
            }
          >
            2
          </StepNumber>
          <p>Concordar</p>
          <hr />
          <StepNumber
            status={
              currentStep > 3
                ? "passed"
                : currentStep === 3
                ? "current"
                : "pending"
            }
          >
            3
          </StepNumber>
          <p>Assinar</p>
        </StepContainer>

        <ButtonContainer showButton={showButton}>
          <Button
            backgroundColor="#355B94"
            hoverBackgroundColor="#32568C"
            isFilled={true}
            height="30px"
            showButton={showButton}
          >
            {urlSettings && <Link to={urlSettings}>Editar perfil</Link>}
          </Button>
        </ButtonContainer>
      </ContentWrapper>
    </HeaderWrapper>
  );
};

export default Header;
